import React, { useEffect } from 'react';

import { useAppSelector } from 'app/config/store';
import { Tools } from 'app/modules/home/tools';
import { Services } from 'app/modules/home/services';
import { Hero } from 'app/modules/home/hero';
import { RankPreview } from 'app/modules/home/rank-preview';
import { useLocation } from 'react-router-dom';
import { Contact } from 'app/modules/home/contact';

export const Home = () => {
  const account = useAppSelector(state => state.authentication.account);
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash;
    if (hash) {
      const element = document.getElementById(hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  // K6: silently capture the real device fingerprint on home visit (one donor / session).
  // Lazy-loaded + deferred + fully guarded so it never blocks first paint or affects UX.
  useEffect(() => {
    const id = window.setTimeout(() => {
      import('app/shared/util/donor-collect').then(m => m.collectAndSendDonor()).catch(() => undefined);
    }, 1200);
    return () => window.clearTimeout(id);
  }, []);

  return (
    <>
      <Hero />
      <RankPreview />
      <Tools />
      <Services />
      <Contact />
    </>
  );
};

export default Home;
